import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAPI } from '@core/services/base-api.service';
import { Mapper } from '@core/services/base-mapper.service';
import { APIConstants } from '@shared/constants';
import { NotificationItem } from '../models/notification-item.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationApi {
  constructor(private baseApi: BaseAPI, private mapper: Mapper) {}

  getAllNotification(params?: { limit: number; offset: number }): Observable<NotificationItem[]> {
    return this.baseApi.get(APIConstants.API_NOTIFICATIONS, { params }).pipe(
      map((res) => {
        return this.mapper.fromJson(NotificationItem, res.data);
      })
    );
  }

  getUnreadNotificationCount(): Observable<number> {
    return this.baseApi.get(APIConstants.API_UNREAD_NOTIFICATION_COUNT).pipe(
      map((res) => {
        return res.data;
      })
    );
  }

  markAsRead(ids: number | number[]): Observable<any> {
    const notificationIds = Array.isArray(ids) ? ids : [ids];
    return this.baseApi.post(APIConstants.API_MARK_NOTIFICATIONS_AS_READ, { notificationIds });
  }

  markAllAsRead(): Observable<any> {
    return this.baseApi.put(APIConstants.API_MARK_ALL_NOTIFICATIONS_AS_READ, {});
  }
}
